<div class="no-access" role="alert" aria-live="assertive" >
    <h1>Acceso no autorizado</h1>
    <p>Lo sentimos, esta sección no está accesible para tu cuenta.</p>
    <button type="button" (click)="goBack()">Volver</button>
</div>
